import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MarkdownParser from './MarkdownParser';
import FilterButton from './FilterButton';

export default function CustomTextarea({ id, value, onChange }) {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      <div className="flex justify-end mb-2">
        <FilterButton
          label="Write"
          onClick={() => setShowPreview(false)}
          isActive={!showPreview}
          isStart
        />
        <FilterButton
          label="Preview"
          onClick={() => setShowPreview(true)}
          isActive={showPreview}
          isEnd
        />
      </div>
      {showPreview ? (
        <div className="mt-1 px-6 py-4 rounded-lg border-2 border-zinc-500 dark:border-zinc-400">
          <MarkdownParser content={value} />
        </div>
      ) : (
        <>
          <textarea
            id={id}
            className="w-full h-64 cursor-text border-2 border-zinc-500 dark:border-zinc-400 rounded-lg py-2 px-3 mt-1 text-base outline-none text-zinc-500 dark:text-zinc-400 bg-white dark:bg-zinc-800 focus:border-cyan-500 dark:focus:border-cyan-600 focus-visible:border-cyan-500 dark:focus-visible:border-cyan-600"
            value={value}
            onChange={onChange}
          />
          <p className="text-xs text-right font-light mt-2">
            Styling with Markdown is supported
          </p>
        </>
      )}
    </>
  );
}

CustomTextarea.propTypes = {
  /** Id of the textarea input */
  id: PropTypes.string.isRequired,
  /** Value of the textarea - that can be string, HTML or Markdown */
  value: PropTypes.string.isRequired,
  /** Action to be called when input is changed */
  onChange: PropTypes.func.isRequired,
};
